export default __webpack_public_path__ + "images/6600c580bb1a9c38e4399400c5c3f1b2.png";